import $ from 'jquery';

export default function () {
    $('.tabsi').each(function () {
        let buttons = $(this).find('.tabsi__buttons > div');
        let content = $(this).find('.tabsi__content > div');

        buttons.click(function () {
            if(!$(this).hasClass('tabsi__active')) {
                buttons.removeClass('tabsi__active');
                $(this).addClass('tabsi__active');
                let activeIndex = buttons.index($(this));

                content.each(function () {
                    if(+$(this).attr('data-i') === +activeIndex){
                        $(this).css('display','block');
                    } else {
                        $(this).css('display','none');
                    }
                })
            }
        });
    });
}
